import React, { useState } from 'react';
import { Modal } from '@agencypmg/alli';

export default function LogOutWarning({ onStay, onLeave }) {
    return (
        <Modal
            title="You Are Being Logged Out"
            visible={true}
            onOk={onLeave}
            okText="Log Out"
            onCancel={onStay}
            cancelText="Stay"
        >
            <p>You are about to be logged out due to being idle. Click "Stay" to stay logged in.</p>
        </Modal>
    );
}
